import { useEffect, useState } from "react";
import { getUserOrders } from "../services/orderService";
import OrderCard from "../components/OrderCard/OrderCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import {
  Clock3,
  Package,
  Truck,
  XCircle,
  Info,
  ChevronDown,

} from "lucide-react";
import noOrderImage from "../assets/images/no-order1.webp";
import DashboardOrderSkeleton from "./Dashboard/Skeleton/Orders/DashboardOrderSkeleton";


export default function DashboardOrder() {
  const [data, setData] = useState({
    ordersAdvice: [],
    orders: [],
    ordersProccess: [],
    ordersDelivery: [],
    ordersCancel: [],
    pharmacy: [],
    offers: [],
    orderWaitCount: 0,
  });

  const [visibleCounts, setVisibleCounts] = useState({
    advice: 10,
    waiting: 10,
    processing: 10,
    delivered: 10,
    cancelled: 10,
  });
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState("");

  const [activeTab, setActiveTab] = useState("waiting");

  const tabs = [
    { key: "advice", label: "مشاوره ها", field: "ordersAdvice", icon: Info },
    { key: "waiting", label: "در انتظار بررسی", field: "orders", icon: Clock3 },
    {
      key: "processing",
      label: "در حال پردازش",
      field: "ordersProccess",
      icon: Package,
    },
    {
      key: "delivered",
      label: "تحویل شده",
      field: "ordersDelivery",
      icon: Truck,
    },
    {
      key: "cancelled",
      label: "لغو شده",
      field: "ordersCancel",
      icon: XCircle,
    },
  ];



  useEffect(() => {

    const loadOrders = async () => {

      try {

        setLoading(true);

        const response = await getUserOrders();
         setData(response);

      } catch (error) {

        console.error("Failed to load Orders:", error);

        setError("Orders not found.");

      } finally {

        setLoading(false);
      }
    };

    loadOrders();

  }, []);



  const getOrdersByTab = () => {
    switch (activeTab) {
      case "advice":
        return data.ordersAdvice;
      case "waiting":
        return data.orders;
      case "processing":
        return data.ordersProccess;
      case "delivered":
        return data.ordersDelivery;
      case "cancelled":
        return data.ordersCancel;
      default:
        return [];
    }
  };

  const activeTabInfo = tabs.find((tab) => tab.key === activeTab);
  const ordersToShow = getOrdersByTab();
  const showMore = () => {
    setVisibleCounts((prev) => ({
      ...prev,
      [activeTab]: prev[activeTab] + 10,
    }));
  };

  const visibleData = ordersToShow.slice(0, visibleCounts[activeTab]);

  useEffect(() => {
    const img = new Image();
    img.src = "/images/no-order1.webp";
  }, []);


  if (loading) {
  return <DashboardOrderSkeleton />;
}

  // if (loading) {
  //   return (
  //     <div className="loader-wrapper">
  //       <div className="loading">
  //         <p>Helloooooooooooooooooo</p>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //       </div>
  //     </div>
  //   );
  // }


  if (error || !data) {
    return (
      <div className="content-detail">
        <h2>Orders not found</h2>
      </div>
    );
  }

  return (
    <div className="wrapper">
      <h2>
        <span>سفارش های من</span>
      </h2>

      {/* Tabs */}
      <div className="orderTabsTitle">
        <Swiper
          dir="rtl"
          slidesPerView={"auto"}
          spaceBetween={1}
          className="order-tabs-swiper"
        >
          {tabs.map((tab) => (
            <SwiperSlide
              className="!w-auto"
              key={tab.key}
              style={{ width: "auto" }}
            >
              <button
                onClick={() => setActiveTab(tab.key)}
                className={`order-tab ${activeTab === tab.key ? "active" : ""}`}
              >
                <span>{tab.label}</span>

                <span className="order-count">
                  {data[tab.field]?.length || 0}
                </span>
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Orders List */}
      <div>
        {visibleData.length === 0 ? (
          <div className="orderNone">
            <p>سفارش فعالی در این صفحه وجود ندارد</p>
            <div>
              <img src={noOrderImage} alt="No active orders" />
             </div>
          </div>
        ) : (
          visibleData.map((order) => (
            <OrderCard
              key={order.id}
              order={order}
              tab={activeTabInfo}
              Icon={activeTabInfo?.icon}
            />
          ))
        )}

        <div className="wrapper-footer">
          {ordersToShow.length > visibleCounts[activeTab] && (
            <button onClick={showMore} className="show-more-btn">
              نمایش بیشتر
              <ChevronDown color="#95b73c" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
